import PartAutocomplete from "../../../../../../../../components/text-fields/autocomplete/part-autocomplete";
import CustomerAutocomplete from "../../../../../../../../components/text-fields/autocomplete/customer-autocomplete";
import TerritoryAutocomplete from "../../../../../../../../components/text-fields/autocomplete/territory-autocomplete";
import WarehouseAutocomplete from "../../../../../../../../components/text-fields/autocomplete/warehouse-autocomplete";
import VendorAutocomplete from "../../../../../../../../components/text-fields/autocomplete/vendor-autocomplete";
import SalesPersonAutocomplete from "../../../../../../../../components/text-fields/autocomplete/sales-person-autocomplete";
import ExternalCustomerAutocomplete from "../../../../../../../../components/text-fields/autocomplete/customer-autocomplete/external-customer";
import ExternalPartAutocomplete from "../../../../../../../../components/text-fields/autocomplete/part-autocomplete/external-part";
import IndustryPropertyOptionsAutocomplete from "../../../../../../../../components/text-fields/autocomplete/industry-property-options-autocomplete";
import PartnersAutocomplete from "../../../../../../../../components/text-fields/autocomplete/partners-autocomplete";
import TagAutocomplete from "../../../../../../../../components/text-fields/autocomplete/tag-autocomplete";
import FormsAutocomplete from "../../../../../../../../components/text-fields/autocomplete/forms-autocomplete";
import ProductRelationAutocomplete from "../../../../../../../../components/text-fields/autocomplete/product-relation-autocomplete";
import {PreventativeAutocompleteType} from "../../../engine/preventative-interactions/shared";

/**
 * @type {Record<string, React.ComponentType<any>>}
 */
export const preventativeAutocompleteComponentByType = {
    [PreventativeAutocompleteType.PART]: PartAutocomplete,
    [PreventativeAutocompleteType.EXTERNAL_PART]: ExternalPartAutocomplete,
    [PreventativeAutocompleteType.CUSTOMER]: CustomerAutocomplete,
    [PreventativeAutocompleteType.EXTERNAL_CUSTOMER]: ExternalCustomerAutocomplete,
    [PreventativeAutocompleteType.TERRITORY]: TerritoryAutocomplete,
    [PreventativeAutocompleteType.WAREHOUSE]: WarehouseAutocomplete,
    [PreventativeAutocompleteType.VENDOR]: VendorAutocomplete,
    [PreventativeAutocompleteType.SALES_PERSON]: SalesPersonAutocomplete,
    [PreventativeAutocompleteType.INDUSTRY_PROPERTY_OPTIONS]: IndustryPropertyOptionsAutocomplete,
    [PreventativeAutocompleteType.PARTNER]: PartnersAutocomplete,
    [PreventativeAutocompleteType.TAG]: TagAutocomplete,
    [PreventativeAutocompleteType.FORM]: FormsAutocomplete,
    [PreventativeAutocompleteType.PRODUCT_RELATION]: ProductRelationAutocomplete,
};

/**
 * @param {string} [fieldType]
 * @returns {React.ComponentType<any>|null}
 */
export const getPreventativeAutocompleteComponent = (fieldType) =>
    preventativeAutocompleteComponentByType[fieldType] ?? null;
